import axios from "axios";

const tokenHttpClient = axios.create();

export default tokenHttpClient;
